import { Component, Vue } from 'vue-property-decorator';

import { ContentDayByDayBlockViewModel } from './ContentDayByDayModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import ContentTextGenericModule from '@/modules/ContentTextGenericModule/ContentTextGenericModule.vue';
import HygieneTable from './HygieneTable/HygieneTable.vue';

@Component({
  components: { ContentTextGenericModule, HygieneTable },
  props: getComponentProps<ContentDayByDayBlockViewModel>({
    Prices: {
      Header: '',
      HeaderRow: {
        FirstCell: 'Occupancy',
        Cells: ['2020', '2021'],
      },
      Rows: [
        {
          FirstCell: 'Double Occupancy',
          Cells: ['$1,190', '$1,290'],
        },
        {
          FirstCell: 'Single Occupancy',
          Cells: ['$2,190', '$2,400'],
        },
      ],
    },
    CostIncludes: '',
    CostNotIncludes: '',
    Text:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    Days: [
      {
        Title: 'Seattle/Embark',
        Number: '1',
        Text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      },
      {
        Title: 'In the sea',
        Number: '2-4',
        Text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      },
    ],
  }),
})
export default class ContentDayByDayModule extends Vue {
  p!: ContentDayByDayBlockViewModel;

  textData() {
    return {
      Text: this.p.Text,
      IsCentered: true,
      IsDropLetter: true,
    };
  }

  daysData() {
    return {
      Text: this.daysFormat(),
      IsCentered: true,
      IsDropLetter: false,
    };
  }

  costData() {
    return {
      Text: this.costFormat(),
      IsCentered: true,
      IsDropLetter: false,
    };
  }

  costFormat() {
    const includeText = this.p.CostIncludes
      ? `<h5>Cost Includes:</h5>${this.p.CostIncludes}`
      : '';
    const notInclude = this.p.CostNotIncludes
      ? `<h5>Not included:</h5>${this.p.CostNotIncludes}`
      : '';
    return `${includeText} ${notInclude}`;
  }

  daysFormat() {
    return this.p.Days
      ? this.p.Days.map((d) => `<h5>Day ${d.Number} - ${d.Title}</h5> ${d.Text}`).join('')
      : '';
  }
}
